import React from "react";

export default function CinematicLoader({ label = "Your Producer is composing your blueprint" }) {
  return (
    <div className="cine-overlay" data-testid="blueprint-loader">
      <div className="cine-bars" aria-hidden>
        <span className="cine-bar" />
        <span className="cine-bar" />
        <span className="cine-bar" />
        <span className="cine-bar" />
        <span className="cine-bar" />
      </div>
      <div className="eyebrow eyebrow-muted">Brand New Money Films</div>
      <div className="font-display text-[22px] md:text-[28px] tracking-[-0.02em] text-ink max-w-[640px] text-center px-6">
        {label}<span className="font-serif-italic text-denim-bnm">.</span>
      </div>
      <div className="text-muted-ink text-sm max-w-[480px] text-center px-8">
        Drafting the creative direction, costing the shoot, and pulling the right crew together.
      </div>
    </div>
  );
}
